import { render, staticRenderFns } from "./RoteirizacaoWeekdayFilter.vue?vue&type=template&id=63602715&scoped=true&"
import script from "./RoteirizacaoWeekdayFilter.vue?vue&type=script&lang=js&"
export * from "./RoteirizacaoWeekdayFilter.vue?vue&type=script&lang=js&"
import style0 from "./RoteirizacaoWeekdayFilter.vue?vue&type=style&index=0&id=63602715&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63602715",
  null
  
)

export default component.exports